import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../shared";
import { currentLanguage, isBefore2017, logEvent, navigationWithEvents } from "../../util/common";
import CancelAppointmentModal from "./CancelAppointmentModal";
import moment from "moment";
import { UserService } from "../../services";
import { Icon } from "../shared";
import ExpressNotificationModal from "./ExpressNotificationModal";
import { useAppNavigation } from "../../hooks";

const AppointmentCards = ({ appointment, fetchAppointments }) => {
  const { t } = useTranslation();
  const { localeRoutes, toUrlWithData } = useAppNavigation();

  const [showCancelModal, setShowCancelModal] = useState(false);
  const [notificationsModal, setNotificationsModal] = useState(false);
  const [cancelAppointmentId, setCancelAppointmentId] = useState("");

  const lang = currentLanguage();
  const {
    _id,
    date,
    carId,
    otherBrand,
    otherModel,
    branchId,
    services,
    quoteService,
    carNumberPlate,
    estimationId,
    isCanceled,
    isExpired,
    expressDocuments,
    expressComments,
    order,
    _order,
    isPaidService,
    isPaid,
    userQuotation,
    canReschedule,
    collectionAndDelivery
  } = appointment;

  const isOrderCompleted =
    order[0]?.offerCompletedBy ||
    order[0]?.variantDeliveredBy ||
    _order[0]?.subscriptionCompletedBy;

  const startCancellation = async (id) => {
    logEvent("Appointment", "cancel_appointment_button_click", "Cancel Appointment Button");
    setShowCancelModal(true);
    setCancelAppointmentId(id);
  };
  const unseenComments = expressComments?.filter((comment) => !comment?.seen).length || 0;

  const readComments = async () => {
    try {
      setNotificationsModal(true);
      if (unseenComments) await UserService.updateSeenStatus(_id, expressComments[0]?.user);
    } catch (error) {
      console.error(error);
    }
  };

  const closeNotificationModal = async () => {
    if (unseenComments) await fetchAppointments();
    setNotificationsModal(false);
  };

  return (
    <>
      <div className="col-sm-12 col-md-6 col-lg-4 col-xl-3">
        <div
          className={`appointments_content ${
            isCanceled || isExpired || isOrderCompleted ? "grey" : ""
          }`}>
          <div>
            <h2 className="card-heading">
              {moment(date.slice(0, 10)).format("MMMM DD, YYYY")} (
              {services[0].newSlot || services[0].slot})
              {expressDocuments?.length ? (
                <span className="icon-container" onClick={readComments}>
                  <Icon iconName="bell" className="notification-icon" />
                  {unseenComments > 0 && <span className="red-dot"></span>}
                </span>
              ) : null}
            </h2>
            <p>
              <span>{t("track.services")}: </span>
              {services[0]?.serviceId?.name?.["value_" + lang] ||
                quoteService[0]?.serviceName?.["value_" + lang]}
            </p>
            <p>
              <span>{t("track.location")}: </span>
              {branchId?.name?.["value_" + lang]},{" "}
              {lang === "en" ? branchId?.city : branchId?.cityNameAr}
            </p>
            <p>
              <span>{t("track.carDetails")}: </span>
              {otherBrand || carId?.brand?.["value_" + lang]}{" "}
              {otherModel || carId?.product?.["value_" + lang]}, {isBefore2017(carId?.modelYear)} (
              {carNumberPlate.toUpperCase()})
            </p>
          </div>
          <div className="re-appointment-btn">
            {!order[0]?.isRefunded ? (
              isCanceled ? (
                <span>
                  <Icon iconName="xmark" />
                  {t("track.thisAppointmentIsCancelled")}
                </span>
              ) : isExpired ? (
                <span>
                  <Icon iconName="hourGlass" />
                  {t("track.thisAppointmentIsExpired")}
                </span>
              ) : isOrderCompleted ? (
                <span className="completed">
                  <Icon iconName="check" />
                  {t("track.appointmentCompleted")}
                </span>
              ) : (
                <>
                  {(!collectionAndDelivery || canReschedule) && (
                    <Button
                      type="white"
                      action={() =>
                        navigationWithEvents(
                          "Re-schedule Appointment",
                          "Rescheduling Appointment ",
                          toUrlWithData(`${localeRoutes.appointment[lang]}/${_id}`, {
                            quotationId: userQuotation
                          })
                        )
                      }>
                      {t("track.rescheduleAppointment")}
                    </Button>
                  )}
                  {!isPaid && (
                    <Button action={() => startCancellation(_id)} type="white">
                      {t("track.cancelAppointment")}
                    </Button>
                  )}
                </>
              )
            ) : (
              <span className="bg-info">{t("track.appointmentRefunded")}</span>
            )}
          </div>
        </div>
      </div>

      <CancelAppointmentModal
        show={showCancelModal}
        fetchAppointments={fetchAppointments}
        toCancel={cancelAppointmentId}
        estimationId={estimationId}
        order={order}
        isPaidService={isPaidService}
        closeModal={() => setShowCancelModal(false)}
      />

      <ExpressNotificationModal
        show={notificationsModal}
        close={closeNotificationModal}
        appointment={appointment}
        notifications={appointment.expressComments}
      />
    </>
  );
};

export default React.memo(AppointmentCards);
